export const SCHOOL_LOCK_START_DATE = "SchoolLockStartDate";
export const SCHOOL_LOCK_END_DATE = "SchoolLockEndDate";
export const ANDROID_APP_URL_SETTING = "ProspectLinkAndroidAppURL";
export const APPLE_APP_URL_SETTING = "ProspectLinkAppleAppURL";
export const LAST_DAY_OF_DRAFT = "LastDayOfDraft";
export const HIGH_SCHOOL_RECOVERY_START_DATE = "HsRecoveryStartDate";
export const HIGH_SCHOOL_RECOVERY_END_DATE = "HsRecoveryEndDate";
export const COLLEGE_RECOVERY_START_DATE = "CollegeRecoveryStartDate";
export const COLLEGE_RECOVERY_END_DATE = "CollegeRecoveryEndDate";
export const PROSPECT_GAME_CREATION_FREEZE_START_DATE = "ProspectGameCreationFreezeStartDate";
export const PROSPECT_GAME_CREATION_FREEZE_END_DATE = "ProspectGameCreationFreezeEndDate";
